/**
 * Gharamiat brand tokens: the single source for the colours, type and shape
 * described in docs/brand-guidelines.md. tailwind.config.js reads this file,
 * so a change here reaches every utility class.
 */
export const BRAND_NAME = { en: 'Gharamiat', ar: 'غراميات' } as const;

export const BRAND_DOMAIN = 'gharamiat.com';

export const BRAND_COLORS = {
  lipstick: '#F0304F',
  'lipstick-deep': '#D11F42',
  'lipstick-dark': '#B3103E',
  ink: '#1A0F2A',
  cream: '#FFF6EF',
  blush: '#FFB3C1',
  lavender: '#A78BFA',
  gold: '#FBBF24',
} as const;

/**
 * Support colours that are not part of the logo palette. `lipstick-soft` is the
 * lightened lipstick for accent text and icons on the dark surfaces and on the
 * `lipstick/15..20` tint (>= 4.6:1 on every plum surface); `lipstick-deep`
 * (the brand hover) is darker than the base and too dim for text on dark.
 */
export const SUPPORT_COLORS = {
  'lipstick-soft': '#FF5C84',
} as const;

/** App surfaces (dark theme), unchanged from the Romantic Night scale. */
export const SURFACE_COLORS = {
  base: '#08040F',
  surface: '#0E0814',
  elevated: '#1C1028',
  overlay: '#261535',
  sheet: '#130B1E',
  card: '#1C1028',
} as const;

export const BRAND_FONTS = {
  display: ['"Inter Display"', 'Inter', 'system-ui', 'sans-serif'],
  sans: ['Inter', 'system-ui', '-apple-system', 'sans-serif'],
  arabic: ['Cairo', 'Inter', 'system-ui', 'sans-serif'],
  mono: ['ui-monospace', 'SFMono-Regular', 'Menlo', 'monospace'],
} as const;

export const BRAND_RADII = {
  tile: '16px',
  bubble: '24px',
  pill: '9999px',
} as const;

export const BRAND_SHADOWS = {
  glow: '0 0 24px rgba(240, 48, 79, 0.35)',
  'glow-strong': '0 0 24px rgba(240, 48, 79, 0.55)',
  'glow-gold': '0 0 20px rgba(251, 191, 36, 0.3)',
  card: '0 8px 32px rgba(0, 0, 0, 0.5)',
  'card-lg': '0 16px 48px rgba(0, 0, 0, 0.7)',
} as const;

/** Public paths of the logo files (served from public/brand). */
export const BRAND_LOGO = {
  light: '/brand/gharamiat-logo-light.svg',
  dark: '/brand/gharamiat-logo-dark.svg',
  icon: '/brand/gharamiat-icon.svg',
} as const;
